<template>
  <div class="col-sm-6 col-lg-4 col-xl-3" :class="{'col-6': arrangeTwoColsForMobile}">
    <div class="collage-photo-item" :class="{'cursor-pointer': !isUnlocked }">
      <div class="collage-photo-item__image-container" @click="$emit('zoom-clicked', photo)">
        <img v-lazy="photo.image_url" class="collage-photo-item__image" alt="">
      </div>
    </div>
  </div>
</template>


<script>
import {observeMedia} from "@/utils/media";

export default {
  components: {

  },

  props: {
    photo: {
      type: Object,
      required: true
    },
    arrangeTwoColsForMobile: {
      type: Boolean,
      default: true,
      required: false
    },
    isUnlocked: {
      type: Boolean,
      default: false
    },

    hasPhotoOriginal: {
      type: Boolean,
      default: false
    },

    dtPhotosHdAvailableFormatted: {
      type: String,
      default: ''
    },

    enableZoom: {
      type: Boolean,
      default: true
    },
  },

  data() {
    return {

    }
  },

  mounted() {
    this.observeMedia(this.$el, '.collage-photo-item', this.photo.id)
  },
  methods:{
    observeMedia,
  }
}
</script>
